export const HEADLINE_MESSAGE_PREFIX_MAP = {
  a: 'Is your',
  b: 'How does your',
};

const ratesHeadlineMessageSuffixMap = {
  a: "falling behind today's top rates?",
  b: 'compare?',
};

const checkingHeadlingMessageSuffixMap = {
  a: "falling behind today's top accounts?",
  b: 'compare?',
};

export const HEADLINE_MESSAGE_PRODUCT_TYPE_MAP = {
  'checking-accounts': checkingHeadlingMessageSuffixMap,
  'free-checking-accounts': checkingHeadlingMessageSuffixMap,
  'online-checking-accounts': checkingHeadlingMessageSuffixMap,
  'high-yield-online-savings-accounts': ratesHeadlineMessageSuffixMap,
  'cd-rates': ratesHeadlineMessageSuffixMap,
};

const ratesSubheadlineMessageMap = {
  a: 'Answer a few quick questions to see where you stand.',
  b: "Get a free personalized analysis comparing your accounts to today's top rates.",
};

const checkingAccountSubheadlineMessageMap = {
  a: 'Answer a few quick questions to see where you stand.',
  b: "Get a free personalized analysis comparing your accounts to today's top accounts.",
};

export const SUBHEADLINE_MESSAGE_PRODUCT_TYPE_MAP = {
  'checking-accounts': checkingAccountSubheadlineMessageMap,
  'free-checking-accounts': checkingAccountSubheadlineMessageMap,
  'online-checking-accounts': checkingAccountSubheadlineMessageMap,
  'high-yield-online-savings-accounts': ratesSubheadlineMessageMap,
  'cd-rates': ratesSubheadlineMessageMap,
};

export const CALL_TO_ACTION_MESSAGE_MAP = {
  a: `Get Started`,
  b: `Compare Now`,
};
